import React from 'react';

function GitRepositoryHeader() {
  return (<>
    <header className="git-repository-header">Git repository 👉🏻<a href="https://github.com/lorenzoVwebDev/text-analyzer">Text-Analyzer</a></header>
  </>)
}

export default GitRepositoryHeader;